import React, { Component } from 'react';

export class SelectSublocation extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        console.log("SUBLOCATION SEARCH RESULTS", this.props.sublocationSearchResults);
        const selectSublocationFunction = this.props.selectSublocation;
        const useCheckboxes = this.props.useCheckboxes;
        return (
            <>
                <div className="select-sublocation">
                    <table>
                        <thead>
                            <tr>
                                {useCheckboxes && <th>Select</th>}
                                <th>Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.props.sublocationSearchResults.map((sublocation, index) => {
                                    return (
                                        <tr key={sublocation.id} onClick={() => { selectSublocationFunction(sublocation) }}>
                                            {
                                                this.props.useCheckboxes &&
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={this.props.sublocationId == sublocation.id}
                                                        onChange={(e) => e.stopPropagation()} // Only needed if you want to block event bubbling
                                                    />
                                                </td>
                                            }
                                            <td>{sublocation.location} : {sublocation.name}</td>
                                        </tr>
                                    );
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </>
        );
    }
}